import React, { useState } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { FaPlus, FaTrash } from 'react-icons/fa';
import CreatableSelect from 'react-select/creatable';

const TubeInput = ({ 
  tubes = [], 
  onChange, 
  disabled = false,
  tubeModelOptions = [],
  tubeBrandOptions = [],
  onCreateTubeModel = () => {},
  onCreateTubeBrand = () => {}
}) => {
  const [newTube, setNewTube] = useState({ model: '', brand: '' });

  const handleAddTube = () => {
    if (newTube.model.trim() && newTube.brand.trim()) {
      const updatedTubes = [...tubes, { ...newTube }];
      onChange(updatedTubes);
      setNewTube({ model: '', brand: '' });
    }
  };

  const handleRemoveTube = (index) => {
    const updatedTubes = tubes.filter((_, i) => i !== index);
    onChange(updatedTubes);
  };

  const handleTubeChange = (index, field, value) => {
    const updatedTubes = [...tubes];
    updatedTubes[index] = { ...updatedTubes[index], [field]: value };
    onChange(updatedTubes);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTube();
    }
  };

  return (
    <div style={{ width: '100%' }}>
      {/* Existing Tubes */}
      {tubes.map((tube, index) => (
        <div key={index} className="d-flex gap-2 mb-3">
          <div style={{ flex: 2 }}>
            <CreatableSelect
              styles={{ 
                container: (provided) => ({ ...provided, flex: '2' }),
                control: (provided) => ({ ...provided, minHeight: '38px' })
              }}
              placeholder="e.g. A68ADT25X01"
              options={tubeModelOptions}
              value={tube.model ? { label: tube.model, value: tube.model } : null}
              onChange={(selected) => handleTubeChange(index, 'model', selected?.value || '')}
              onCreateOption={(inputValue) => {
                onCreateTubeModel(inputValue);
                handleTubeChange(index, 'model', inputValue);
              }}
              isDisabled={disabled}
              isClearable
              classNamePrefix="dark-select"
            />
          </div>
          <div style={{ flex: 1 }}>
            <CreatableSelect
              styles={{ 
                container: (provided) => ({ ...provided, flex: '1' }),
                control: (provided) => ({ ...provided, minHeight: '38px' })
              }}
              placeholder="Brand"
              options={tubeBrandOptions}
              value={tube.brand ? { label: tube.brand, value: tube.brand } : null}
              onChange={(selected) => handleTubeChange(index, 'brand', selected?.value || '')}
              onCreateOption={(inputValue) => {
                onCreateTubeBrand(inputValue);
                handleTubeChange(index, 'brand', inputValue);
              }}
              isDisabled={disabled}
              isClearable
              classNamePrefix="dark-select"
            />
          </div>
          <Button
            variant="outline-danger"
            onClick={() => handleRemoveTube(index)}
            disabled={disabled}
            style={{ width: '40px', height: '40px', padding: 0 }}
          >
            <FaTrash />
          </Button>
        </div>
      ))}

      {/* Add New Tube */}
      <div className="d-flex gap-2 mb-3">
          <div style={{ flex: 2 }}>
            <CreatableSelect
              styles={{ 
                container: (provided) => ({ ...provided, flex: '2' }),
                control: (provided) => ({ ...provided, minHeight: '38px' })
              }}
              placeholder="e.g. A68ADT25X01"
              options={tubeModelOptions}
              value={newTube.model ? { label: newTube.model, value: newTube.model } : null}
              onChange={(selected) => setNewTube(prev => ({ ...prev, model: selected?.value || '' }))}
              onCreateOption={(inputValue) => {
                onCreateTubeModel(inputValue);
                setNewTube(prev => ({ ...prev, model: inputValue }));
              }}
              isDisabled={disabled}
              isClearable
              classNamePrefix="dark-select"
            />
          </div>
          <div style={{ flex: 1 }}>
            <CreatableSelect
              styles={{ 
                container: (provided) => ({ ...provided, flex: '1' }),
                control: (provided) => ({ ...provided, minHeight: '38px' })
              }}
              placeholder="Brand"
              options={tubeBrandOptions}
              value={newTube.brand ? { label: newTube.brand, value: newTube.brand } : null}
              onChange={(selected) => setNewTube(prev => ({ ...prev, brand: selected?.value || '' }))}
              onCreateOption={(inputValue) => {
                onCreateTubeBrand(inputValue);
                setNewTube(prev => ({ ...prev, brand: inputValue }));
              }}
              isDisabled={disabled}
              isClearable
              classNamePrefix="dark-select"
            />
          </div>
          <Button
            variant="outline-primary"
            onClick={handleAddTube}
            disabled={disabled || !newTube.model.trim() || !newTube.brand.trim()}
            style={{ width: '40px', height: '40px', padding: 0 }}
          >
            <FaPlus />
          </Button>
      </div>
    </div>
  );
};

export default TubeInput; 